import { DownloadOutlined } from '@ant-design/icons'
import { Button, ConsoleCard, CardsCol, CardsRow, message } from 'admin-web-ui'
import React from 'react'
import { useAsyncFn } from 'react-use'
import { useProjectContext } from '../../../containers/Project'
import { downloadTextFile } from '../../../utils/download'
import { fetchClientConfig } from './fetch-client-config'

export const ClientConfig: React.FC = () => {
  const { projectClient, currentProject } = useProjectContext()

  const [downloadState, download] = useAsyncFn(async () => {
    try {
      const clientConfig = await fetchClientConfig(projectClient)
      downloadTextFile(`sudoplatformconfig.json`, clientConfig)
    } catch {
      message.error(
        'An error occurred downloading the mobile config file. Please try again.',
      )
    }
  }, [projectClient, currentProject])

  return (
    <CardsRow>
      <CardsCol span={24}>
        <ConsoleCard
          title="SDK Config"
          extra={
            <Button
              className="automation-SDKConfigDownloadButton"
              key="download"
              icon={<DownloadOutlined />}
              type="default"
              shape="round"
              onClick={download}
              loading={downloadState.loading}
            >
              Download
            </Button>
          }
        >
          <h3>Download latest SDK config file</h3>
          <p>
            This file contains the latest SDK configuration details such as keys
            and identifiers for services you have enabled.
            <br />
            Learn more about{' '}
            <a
              href="https://docs.sudoplatform.com/guides/users/integrate-the-user-sdk#sdk-configuration"
              target="_blank"
              rel="noopener noreferrer"
            >
              {' '}
              SDK Configs
            </a>
            .
          </p>
        </ConsoleCard>
      </CardsCol>
    </CardsRow>
  )
}
